import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=7b996852&scoped=true&"
import script from "./CategoryFilters.vue?vue&type=script&lang=ts&"
export * from "./CategoryFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=7b996852&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b996852",
  null
  
)

export default component.exports